import React from 'react';
import {BaseMixin, ContentMixin} from './../../common/common.js';

import './label.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: "UU5.Forms.Label",
    classNames: {
      main: "uu5-forms-label"
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    for: React.PropTypes.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      for: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  shouldComponentUpdate(newProps, newState){
    let result = false;
    if (newProps.for != this.props.for || newProps.content != this.props.content || newProps.children != this.props.children) {
      result = true;
    }
    return result;
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMainAttrs(){
    let mainAttrs = this.getMainAttrs();
    this.props.for && (mainAttrs.htmlFor = this.props.for);
    mainAttrs.className += ' ' + this.props.colWidth;
    return mainAttrs;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      <label {...this._getMainAttrs()}>
        {this.getChildren()}
      </label>
    );
  }
  //@@viewOn:render
});


// WEBPACK FOOTER //
// ./forms/internal/label.js